// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"5cf84740","119":"0ddbba2c","142":"7ed985ff","300":"84bcb9ba","398":"b8880baf","588":"a2ca67e8","628":"2f4fa9e8","754":"e50b6d92","976":"74a4b3aa"}[chunkId] + ".chunk.js";
};